// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e4cd296b","container":"a1ba98c9","inner":"baaadbba"};